export default "__VITE_ASSET__x0YtVP1P__"